import Package from "../models/Package";
import t from "../locales/translation";
import {useEffect, useState} from "react";
import PackageGridItem from "./PackageGridItem";
import {PackageBenefitsProps} from "../models/PropsInterface";


const PackageBenefits = (props: PackageBenefitsProps) => {


    /*-----------------------------
     *          STATE
     * ----------------------------*/
    const [packageBenefits, setPackageBenefits] = useState<Package>()


    useEffect(() => {
        if (props.packages && Object.keys(props.packages).length > 0) {
            setPackageBenefits(props.packages.find((pkg) => {
                return pkg.productSettingId === props.selectedId
            }) ?? props.packages[0])
        }
    }, [props.selectedId])

    return (
        packageBenefits &&
       <div
            className={`services-package__col-12`}>
            <div className={`services-package__row services-package__justify-content-center`}>
                {packageBenefits?.benefits.rows.length > 0 && <div className={`services-package__col-12`}>
                    <p className={`package_benefits__greyed_text services-package__mb-0`} style={{fontSize: "15px"}}>{t.benefits}</p>
                    <div className={`package_benefits__line_style`}/>
                </div>}
                <div className="services-package__col-12">
                    {
                        packageBenefits?.benefits?.rows.map(item => {

                            return (
                                <PackageGridItem title={item.title} desc={item.description}
                                                 pillText={item.value ?? ''}></PackageGridItem>
                            )
                        })
                    }
                </div>
                {props.packages?.findIndex(e => e?.service.toLowerCase() === 'turbo' || e?.service.toLowerCase() === 'premium' || e?.service.toLowerCase() === 'bumpup') != -1 &&
                    <div className={`services-package__col-12`}>
                        <p className={`services-package__m-0 package_benefits__font_size_sm package_benefits__greyed_text`}>* {t.numberOfViews}
                        </p>
                        <p className={`services-package__m-0 services-package__mt-1 package_benefits__font_size_sm package_benefits__greyed_text`}>
                            * {t.byPurchasingThe}
                            <a target={"_top"} href={`https://jo.opensooq.com/${props.language}/termOfUse`}
                               className={`services-package__p-1 package_benefits__less_greyed_text`}> {t.termsOfUse}</a> &
                            <a target={"_top"}
                               href={`https://jo.opensooq.com/${props.language}/site/page?view=privacyPolicy`}
                               className={`services-package__p-1 package_benefits__less_greyed_text`}> {t.privacyPolicy}</a>
                        </p>
                    </div>
                }

                    <div className={"services-package__col-12"}>
                        <p className={`services-package__mt-3 package_benefits__font_size_sm`}> {t.doYouNeedHelp} <a target={"_top"}
                                                                                                                     href={`https://jo.opensooq.com/${props.language}/support`}
                                                                                                                     className={`package_benefits__hyperlink`}>{t.contactUs} </a>
                        </p>

                    </div>


            </div>
        </div>

    )
}

export default PackageBenefits